import React from 'react';

export default function IdentityImage({ url, url2, className, large = false, medium = false, project = null, user = null }) {
    let commonClass = 'rounded-full object-cover';
    const noLogoPlaceholder = "static/images/no-logo.png";

    const getPlaceholderText = (type) => {
        switch (type) {
            case 'project':
                if (!project || !project.name) return '';
                const projectWords = project.name.split(' ');
                return projectWords.length > 1
                    ? projectWords[0].charAt(0).toUpperCase() + projectWords[1].charAt(0).toUpperCase()
                    : projectWords[0].charAt(0).toUpperCase();
            case 'user':
                if (!user || !user.firstName) return '';
                return user.firstName.charAt(0).toUpperCase() + user.lastName.charAt(0).toUpperCase()
            default:
                return '';
        }
    };

    const renderPlaceholder = (type, placeholderClass) => (
        <div className={[placeholderClass, commonClass, config.class, className, 'avatar-placeholder bg-slate-900 flex justify-center items-center text-white font-semibold'].join(' ')}>
            {getPlaceholderText(type)}
        </div>
    );

    const renderImage = (imageUrl, config, type) => {
        if (type === 'user' && user && (!imageUrl || imageUrl.length === 0 || imageUrl.includes(noLogoPlaceholder))) {
            return renderPlaceholder('user', 'bg-indigo-800 box-shadow-none');
        }
        if (project && imageUrl && imageUrl.includes(noLogoPlaceholder)) {
            return renderPlaceholder('project', 'bg-slate-900');
        }

        return (
            <img
                className={[commonClass, config.class, className].join(' ')}
                src={imageUrl}
                width={config.width}
                height={config.height}
                alt="identity image"
            />
        );
    };

    const largeConfig = {
        class: 'avatar-big block min-w-20 min-h-20 w-20 h-20 text-lg',
        width: 80,
        height: 80,
    };

    const smallConfig = {
        class: 'avatar-small block min-w-8 min-h-8 w-8 h-8 text-xs ',
        width: 32,
        height: 32,
    };

    const mediumConfig = {
        class: 'avatar-medium block min-w-10 min-h-10 w-10 h-10 text-sm',
        width: 40,
        height: 40,
    };

    const config = large ? largeConfig : medium ? mediumConfig : smallConfig;

    return large || medium ? (
        <div className={'bg-gray-200 rounded-full'}>
            {renderImage(url, config, 'user')}
        </div>
    ) : (
        <ul className="flex flex-wrap justify-center sm:justify-start">
            <li>
                {renderImage(url, config, 'user')}
            </li>
            {url2 && (
                <li className="-ml-2">
                    {renderImage(project.logoUrl, config, 'project')}
                </li>
            )}
        </ul>
    );
}
